import { settings as s } from '../Settings';
import {
	getData,
	postData,
	putData,
	postDataAnonymously,
	putFormData,
	putFormDataWithoutUser,
	FormDataPost,
	postFormData,
} from './apiCalls';

export const testApi = async () => {
	try {
		const response = await getData(`${s.testApi}`);
		return response;
	} catch (err) {
		return null;
	}
};
export const refresh = async (data) => {
	try {
		const response = await postData(`${s.refreshToken}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

export const getVisitCount = async () => {
	try {
		const response = await getData(`${s.mxchvisit.getVisitCount}`);
		return response;
	} catch (err) {
		return null;
	}
};
export const login = async (data) => {
	try {
		const response = await postData(`${s.mxchuser.login}`, data, 'login');
		return response;
	} catch (err) {
		return null;
	}
};

export const logout = async (data) => {
	try {
		const response = await postData(`${s.mxchuser.logout}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

export const register = async (data, user) => {
	try {
		const response = await postData(`${s.mxchuser.register}`, data, 'signup');
		return response;
	} catch (err) {
		return null;
	}
};
// Get Appointment
export const getAppointment = async () => {
	try {
		const response = await getData(`${s.mxchvisit.getAppointment}`);
		return response;
	} catch (err) {
		return null;
	}
};

// Add Appointment
export const addAppointment = async (data) => {
	try {
		const response = await postData(`${s.mxchvisit.addAppointment}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

export const updateAppointment = async (id, data) => {
	try {
		const response = await putData(
			`${s.mxchvisit.updateAppointmentById}${id}/`,
			data
		);
		return response;
	} catch (err) {
		return null;
	}
};

export const getVisit = async () => {
	try {
		const id = localStorage.practice_id;
		const response = await getData(`${s.mxchvisit.getVisit}?practice_id=${id}`);
		return response;
	} catch (err) {
		return null;
	}
};

// cpt codes
export const getCptCodes = async () => {
	try {
		const response = await getData(`${s.mxchkb.getCptCodes}`);
		return response;
	} catch (err) {
		return null;
	}
};
// cpt codes by id
export const getCptCodesId = async (id) => {
	try {
		const response = await getData(`${s.mxchkb.getCptCodes}/${id}`);
		return response;
	} catch (err) {
		return null;
	}
};
// get DX Codes
export const getDxCodes = async () => {
	try {
		const response = await getData(`${s.mxchkb.getDxCodes}`);
		return response;
	} catch (err) {
		return null;
	}
};
// cpt codes by id
export const getDxCodesId = async (id) => {
	try {
		const response = await getData(`${s.mxchkb.getDxCodes}/${id}`);
		return response;
	} catch (err) {
		return null;
	}
};

export const contactUs = async (data, user) => {
	try {
		const response = await postData(`${s.mxchapp.contactUs}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const feedback = async (data, user) => {
	try {
		const response = await postData(`${s.mxchapp.feedback}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const verifyEmail = async (data) => {
	try {
		const response = await postData(
			`${s.mxchuser.verifyEmail}`,
			data,
			'verify'
		);
		return response;
	} catch (err) {
		return null;
	}
};
export const resendCode = async (data) => {
	try {
		const response = await postData(`${s.mxchuser.resendCode}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const forgotPassword = async (data) => {
	try {
		const response = await postData(`${s.mxchuser.forgotPassword}`, data, 'fp');
		return response;
	} catch (err) {
		return null;
	}
};

export const aboutUs = async (data) => {
	try {
		const response = await getData(`${s.mxchapp.aboutUs}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// get cpt by post method
export const postCpt = async (data) => {
	try {
		const response = await postData(`${s.mxchkb.getcptByPost}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// get Dx by post method
export const postDx = async (data) => {
	try {
		const response = await postData(`${s.mxchkb.getDxByPost}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// post add patient detail api

export const postAddPatientData = async (data) => {
	// debugger
	try {
		const resp = await postData(`${s.mxchpatient.addPatient}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// post add patient detail api

export const postAddPatAdmData = async (data) => {
	debugger;
	try {
		const resp = await postData(`${s.mxchpatient.addPatAdmission}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// post patient insurance detail api

export const postAddPatientInsuranceData = async (data) => {
	try {
		const resp = await postData(`${s.mxchpatient.addPatientIns}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

export const postPatNotes = async (data) => {
	debugger;
	try {
		const resp = await postData(`${s.mxchpatient.addPatnotes}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// get add patient detail api

export const getAddPatientDetail = async () => {
	try {
		const response = await getData(`${s.mxchpatient.addPatient}`);
		return response;
	} catch (err) {
		return null;
	}
};

// get add patient admission detail api

export const getAddPatientAdmissionDetail = async () => {
	try {
		const response = await getData(`${s.mxchpatient.getPatAdmissions}`);
		return response;
	} catch (err) {
		return null;
	}
};

// get patient List By Id detail api

export const getPatientListById = async (data) => {
	try {
		const response = await getData(`${s.mxchpatient.getPatientWithId}${data}`);
		return response;
	} catch (err) {
		return null;
	}
};

// get add patient insurance detail api

export const getAddPatientInsDetail = async () => {
	try {
		const response = await getData(`${s.mxchpatient.getPatInsurances}`);
		return response;
	} catch (err) {
		return null;
	}
};
export const getPatientNotes = async (patient_id, practice_id, visit_id) => {
	try {
		const response = await getData(
			`${s.mxchpatient.getPatnotes}`
				.replace('$[patient_id]', patient_id)
				.replace('$[practice_id]', practice_id)
				.replace('$[visit_id]', visit_id)
		);
		return response;
	} catch (err) {
		return null;
	}
};
export const getChargesNotes = async (patient_id, practice_id, visit_id) => {
	try {
		debugger;
		const response = await getData(
			`${s.mxchpatient.getChargesNotes}`
				.replace('$[patient_id]', patient_id)
				.replace('$[practice_id]', practice_id)
				.replace('$[visit_id]', visit_id)
		);
		return response;
	} catch (err) {
		return null;
	}
};
export const getPractices = async () => {
	try {
		const response = await getData(`${s.mxchmaster.getPractices}`);
		return response;
	} catch (err) {
		return null;
	}
};

export const getPracticeStaff = async () => {
	try {
		const id = localStorage.practice_id;
		let url = `${s.mxchmaster.getStaffs}`;
		if (id) {
			url += `?practice_id=` + id;
		}
		const response = await getData(url);
		return response;
	} catch (err) {
		return null;
	}
};

// Update Get Practice Staff By ID
export const updatePracticeStaff = async (id, data) => {
	try {
		const response = await putData(`${s.mxchmaster.updateStaff}${id}/`, data);
		return response;
	} catch (err) {
		return null;
	}
};

export const addStaff = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchmaster.addStaff}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const updateUser = async (data) => {
	try {
		debugger;
		const response = await putData(`${s.mxchuser.updateUser}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const getUser = async () => {
	try {
		debugger;
		const response = await getData(`${s.mxchuser.getUser}`);
		return response;
	} catch (err) {
		return null;
	}
};
export const getPayers = async () => {
	try {
		debugger;
		const response = await getData(`${s.mxchmaster.getPayers}`);
		return response;
	} catch (err) {
		return null;
	}
};
export const getPayerById = async (id) => {
	try {
		debugger;
		const response = await getData(`${s.mxchmaster.getPayerById}`, { id });
		return response;
	} catch (err) {
		return null;
	}
};
export const addPayer = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchmaster.newPayer}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const updatePayer = async (id, data) => {
	try {
		// debugger
		const response = await putData(`${s.mxchmaster.updatePayer}${id}/`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// function for getting data for censusList Screen
export const getPatientList = async (
	id,
	pageNumber,
	patientName,
	proId,
	locId,
	patStatus,
	rows
) => {
	try {
		const response = await postData(`${s.mxchpatient.getPatientLists}`, {
			practice_id: id,
			in_PageNumber: pageNumber,
			in_PatientSearch: patientName,
			in_ProviderId: proId,
			in_LocationId: locId,
			in_PatStatus: patStatus,
			in_Rows: rows,
		});
		return response;
	} catch (err) {
		return null;
	}
};

// function for getting data for admitted patients
export const getAdmittedPatients = async (id) => {
	try {
		const response = await postData(`${s.mxchpatient.getAdmittedPatients}`, {
			practice_id: id,
		});
		return response;
	} catch (err) {
		return null;
	}
};
// GET Patient List Method- Reports component
export const getPatients_reportComponent = async (
	practice_id,
	provider_id
	// location_id
) => {
	try {
		const response = await postData(`${s.mxchpatient.getPatientLists}`, {
			practice_id: practice_id,
			...(provider_id && { in_ProviderId: provider_id }),
			// ...(location_id && { in_LocationId: location_id }),
		});
		return response;
	} catch (err) {
		return null;
	}
};

// function for updating batch info

export const updateBatch = async (id, data) => {
	try {
		const response = await putData(
			`${s.mxchvisit.updateBatcheWithBatchID}${id}/`,
			data
		);

		return response;
	} catch (err) {
		return null;
	}
};
// PracticeStaff Data calling function is here

// export const getPracticeStaff = async () => {

// 	try {

// 		const response = await getData(`${s.mxchmaster.getStaffs}`);

// 		return response;

// 	} catch (err) {

// 		return null;

// 	}

// };
// Get Location
export const getLocation = async () => {
	try {
		const id = localStorage.practice_id;
		let url = `${s.mxchmaster.location}`;
		if (id) {
			url += `?practice_id=` + id;
		}
		const response = await getData(url);
		return response;
	} catch (err) {
		return null;
	}
};

export const addLocation = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchmaster.createLoc}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// Update Location By ID
export const updateLocation = async (id, data) => {
	debugger;
	try {
		const response = await putData(`${s.mxchmaster.updateLoc}${id}/`, data);
		return response;
	} catch (err) {
		return null;
	}
};

// get all messages
export const getMessages = async () => {
	try {
		const response = await getData(`${s.mxchmaster.getMessages}`);
		return response;
	} catch (err) {
		return null;
	}
};

// function for creating new charge/add charge
export const addNewCharge = async (data) => {
	try {
		const response = await postData(`${s.mxchvisit.addVisit}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// updateStatus
export const editStatus = async (data) => {
	try {
		const response = await postData(`${s.mxchvisit.updateStatus}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

// Get visit data By ID
export const getVisitById = async (id) => {
	try {
		const response = await getData(`${s.mxchvisit.getVisitById}${id}/`);
		return response;
	} catch (err) {
		return null;
	}
};
// moving to maximus export
export const moveToMaximusExport = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchimpexp.maximusExport}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const maximusImport = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchimpexp.maximusImport}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const emrExport = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchimpexp.emrExport}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const mxemrimport = async (data) => {
	try {
		debugger;
		const response = await postData(`${s.mxchimpexp.maxEmrImport}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// function for getting data for Batches Details Screen (BatchList API)
export const getBatchesDetails = async () => {
	try {
		const response = await getData(`${s.mxchvisit.getBatches}`);
		return response;
	} catch (err) {
		return null;
	}
};
// get Batches
export const getBatches = async () => {
	try {
		const id = localStorage.practice_id;
		const response = await getData(
			`${s.mxchvisit.getBatches}?practice_id=${id}`
		);
		return response;
	} catch (err) {
		return null;
	}
};
// function for getting data for Batches with batch_id on
export const getBatchesWithbatch_id = async (id) => {
	try {
		const response = await getData(
			`${s.mxchvisit.getBatchesWithBatchID}${id}/`
		);
		return response;
	} catch (err) {
		return null;
	}
};

// create Batches REMEMBER use same getBatches(Settings.js) API with POST method to create Batches and this API is using in move to batch modal
export const createBatches = async (data) => {
	console.log('API is Hit with post and this data', data);
	try {
		const response = await postData(`${s.mxchvisit.getBatches}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

// getUserAssignPractices API for get userpraactice
export const getUserPractices = async (id) => {
	try {
		const response = await getData(
			`${s.mxchmaster.getUserAssignPractices}?practice_id=${id}`
		);
		return response;
	} catch (err) {
		return null;
	}
};

// get Visit List By show in patient List through ID detail api

export const getVisitInPatientListById = async (data) => {
	try {
		const response = await getData(`${s.mxchvisit.getVisitWithId}` + data);
		return response;
	} catch (err) {
		return null;
	}
};

// update patient data using put method

export const putPatientDetail = async (id, data) => {
	try {
		const response = await putData(
			`${s.mxchpatient.updatePatientById}/${id}/`,
			data
		);
		return response;
	} catch (err) {
		return null;
	}
};

// Function For Getting Charges Report Section

export const getChargesReport = async () => {
	try {
		const response = await getData(`${s.mxchvisit.getVisit}`);
		return response;
	} catch (err) {
		return null;
	}
};
// Get visit data By ID
export const editVisitData = async (id, data) => {
	try {
		const response = await putData(`${s.mxchvisit.editVisit}${id}/`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// Get visit data By ID
export const postVisitDatalist = async (data) => {
	try {
		const response = await postData(`${s.mxchvisit.postVisitDataList}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
// Visit Summary
export const getSummaryData = async (data) => {
	try {
		const response = await postData(`${s.mxchvisit.getVisitSummary}`, data);
		return response;
	} catch (err) {
		return null;
	}
};

// PracticeStaff Data calling function is here
// export const getPracticeStaff = async () => {
// 	try {
// 		const response = await getData(`${s.mxchmaster.getStaffs}`);
// 		return response;
// 	} catch (err) {
// 		return null;
// 	}
// };

// get data of patient insurace By id

export const getPatInsById = async (id) => {
	try {
		const response = await getData(`${s.mxchpatient.addPatient}${id}`);
		return response;
	} catch (err) {
		return null;
	}
};

// Get Location Data calling function is here

export const getAlllocations = async () => {
	try {
		const response = await getData(`${s.mxchmaster.location}`);
		return response;
	} catch (err) {
		return null;
	}
};

// post save file api

export const savefilepost = async (data) => {
	try {
		debugger;
		const resp = await FormDataPost(`${s.mxchvisit.savefile}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// post save file api on patient api

export const savefileWithPatient = async (data) => {
	try {
		debugger;
		const resp = await FormDataPost(`${s.mxchpatient.savefile}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// Post Attachment File

export const PostAttahcmentFile = async (data) => {
	try {
		debugger;
		const resp = await postData(`${s.mxchvisit.postAttachment}`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// Put Attachment File

export const PutAttahcmentFile = async (id, data) => {
	try {
		const resp = await putData(`${s.mxchvisit.postAttachment}${id}/`, data);
		return resp;
	} catch (err) {
		return null;
	}
};

// Get Attachment File with patientID

export const GetAttahcmentFile = async (id) => {
	try {
		debugger;
		const resp = await getData(
			`${s.mxchvisit.postAttachment}?patient_id=${id}`
		);
		return resp;
	} catch (err) {
		return null;
	}
};

// Function For Getting Practice Staff API Data used in Batches Report Section

export const getPracticeStaffReport = async () => {
	try {
		const response = await getData(`${s.mxchmaster.getStaffs}`);
		return response;
	} catch (err) {
		return null;
	}
};

// Function For Getting Batches Api Data

export const getBatchesReport = async () => {
	try {
		const response = await getData(`${s.mxchvisit.getBatches}`);
		return response;
	} catch (err) {
		return null;
	}
};

// update patient Insurance data using put method

export const putPatientInsData1 = async (id, data) => {
	debugger;
	try {
		const response = await putData(
			`${s.mxchpatient.updatePatientInsById}/${id}/`,
			data
		);
		return response;
	} catch (err) {
		return null;
	}
};

// update patient admission data using put method

export const putPatAdmData = async (id, data) => {
	try {
		const response = await putData(
			`${s.mxchpatient.updatePatAdmByID}/${id}/`,
			data
		);
		return response;
	} catch (err) {
		return null;
	}
};

// get patient Admission Data By Id

export const getPatAdmId = async (data) => {
	try {
		const response = await getData(`${s.mxchpatient.getPatAdmID}/${data}/`);
		return response;
	} catch (err) {
		return null;
	}
};

// get visit data by ID

export const getVisitDataByID = async (data) => {
	try {
		const response = await getData(`${s.mxchvisit.getVisitDataByID}${data}`);
		return response;
	} catch (err) {
		return null;
	}
};
// for getting userSettings API with get Method to see the list of settingCodes
export const getUserSettings = async () => {
	try {
		const response = await getData(`${s.mxchsettings.getUserSettings}`);
		return response;
	} catch (err) {
		return null;
	}
};

export const postUserSettings = async (data) => {
	try {
		const response = await postData(`${s.mxchsettings.getUserSettings}`, data);
		return response;
	} catch (err) {
		return null;
	}
};
export const updateUserSettings = async (id, data) => {
	try {
		const response = await putData(
			`${s.mxchsettings.getUserSettings}${id}/`,
			data
		);
		return response;
	} catch (err) {
		return null;
	}
};
